<template>
	<span :class="{activeclick: isSortable}" class="nw agenda-th">
		<span :class="isSortedColumn?'boldText':''" @click="sort">{{title}}</span>
		<sym-icon v-if="isSortedColumn && sortOrderAsc" @click="sort" name="caret-up-16-bold" style="padding-left: 3px;"/>
		<sym-icon v-else-if="isSortedColumn" @click="sort" name="caret-down-14-bold" style="padding-left: 3px;"/>
		<input v-if="isFilterable" class="thqbe" :style="inputStyle(modelValue)" placeholder=""
			   :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" style="margin-left: 3px;"
				type="text" size="2" @focusout="$emit('reload')" @keyup.enter="$emit('reload')" @keyup.esc="resetValue">
	</span>
</template>
<style>
	.agenda-th {
		color: var(--agenda-head-fg);
		border-bottom: 1px solid var(--header-separator-color);
		vertical-align: baseline;
		padding: 8px var(--agenda-h-padding) 2px var(--agenda-h-padding);
	}
	
	.agenda-th:hover {
		color: var(--agenda-head-fg-hover);
		border-color: var(--agenda-head-border-color);
	}
</style>
<script setup lang="ts">
	import { computed } from 'vue';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps({
		id: String,
		title: String,
		isSortable: Boolean,
		isFilterable: Boolean,
		sortColumn: String,
		sortOrderAsc: Boolean,
		modelValue: String
	});
	
	const emit = defineEmits(['sortBy', 'reload','update:modelValue']);
	
	const isSortedColumn = computed<boolean>(() => {
		return props.id===props.sortColumn;
	});
	
	function inputStyle(property): string {
		if (Boolean(property)) {
			let width: number = property.length*10+20;
			if (width<50) width=50;
			if (width>120) width=120;
			return "width: "+width+"px;";
		}
		return "";
	}
	
	function sort(): void {
		if (props.isSortable) {
			emit("sortBy", props.id);
		}
	}
	
	function resetValue(event): void {
		emit('update:modelValue', '');
		emit('reload');
		event.target.blur();
	}
	
</script>
